import React from "react";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/constants/content";

export default function ServicesSection() {
  return (
    <section id="services" className="section bg-[#F8FAFC] relative" data-testid="services-section">
      <div className="container-page relative">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <div className="eyebrow mb-3">Our Services</div>
            <h2 className="font-display font-bold text-slate-900 text-3xl md:text-4xl lg:text-5xl tracking-tight">
              Complete home healthcare, <span className="bg-gradient-to-r from-[#0A84FF] to-[#10B981] bg-clip-text text-transparent">tailored to every patient</span>.
            </h2>
          </div>
          <Link to="/services" className="inline-flex items-center gap-1 text-sm font-semibold text-[#0A84FF] hover:gap-2 transition-all" data-testid="services-view-all">
            View all services <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Heart;
            return (
              <motion.div
                key={s.slug}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.35, delay: (i % 4) * 0.06 }}
              >
                <Link
                  to={`/services/${s.slug}`}
                  className="group h-full flex flex-col rounded-2xl border border-slate-200/70 bg-white p-5 md:p-6 hover:border-[#0A84FF]/30 hover:shadow-xl hover:-translate-y-1 transition-all relative overflow-hidden"
                  data-testid={`service-card-${s.slug}`}
                >
                  <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-[#0A84FF] to-[#10B981] opacity-0 group-hover:opacity-100 transition-opacity" />
                  <div className="h-11 w-11 rounded-xl bg-gradient-to-br from-[#0A84FF]/10 to-[#10B981]/10 border border-slate-100 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    <Icon className="h-5 w-5" style={{ color: '#0A84FF' }} />
                  </div>
                  <h3 className="font-display font-semibold text-slate-900 text-base tracking-tight leading-snug">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-[13px] text-slate-600 leading-relaxed flex-1">{s.short}</p>
                  <div className="mt-4 inline-flex items-center gap-1.5 text-[12px] font-semibold text-[#0A84FF] group-hover:gap-2.5 transition-all">
                    Learn more <ArrowUpRight className="h-3.5 w-3.5" />
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
